var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FF100EA3-98AF-4423-BD65-91152595AE58") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C9FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A74E8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-Integrations",
    transform: "translate(-519.000000, -1850.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AppleAppStore",
    transform: "translate(519.000000, 1850.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85497316,0 L35.1450269,0 C40.5877783,0 45,4.41222177 45,9.85497316 L45,35.1450269 C45,40.5877783 40.5877783,45 35.1450269,45 L9.85497316,45 C4.41222177,45 0,40.5877783 0,35.1450269 L0,9.85497316 C0,4.41222177 4.41222177,0 9.85497316,0 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4213887,32.6619649 L14.4256195,32.6633008 L12.887067,35.3281449 C12.32548,36.3008795 11.0815714,36.6341799 10.1088367,36.0725483 C9.1361466,35.5110057 8.80284625,34.2670973 9.36443329,33.2943625 L10.4978504,31.3312574 L10.606605,31.142874 C10.8008669,30.8635947 11.2802423,30.3818145 12.2391265,30.4723543 C12.2391265,30.4723543 14.4955841,30.7172526 14.6588496,31.8900387 C14.6588942,31.8900387 14.6811617,32.2759795 14.4213887,32.6619649 L14.4213887,32.6619649 Z M36.2434764,25.8555387 L31.4456704,25.8555387 C31.1189613,25.8336721 30.9762264,25.7169902 30.9202458,25.6491635 L30.9166829,25.642973 L25.7807668,16.7473631 L25.7741311,16.7518166 L25.4660822,16.3101625 C24.9613219,15.5382364 24.1597355,17.5126089 24.1597355,17.5126089 C23.2026771,19.7125961 24.2955229,22.2139074 24.6766092,22.96989 L31.8100562,35.3253837 C32.3715987,36.2981183 33.6155073,36.6314187 34.5882419,36.0697871 C35.560932,35.5082446 35.8942324,34.2643361 35.3326454,33.2916013 L33.5488382,30.2020265 C33.5143236,30.1272077 33.4541568,29.9239051 33.8199676,29.9231035 L36.2434764,29.9231035 C37.3666948,29.9231035 38.2772586,29.0125397 38.2772586,27.8893211 C38.2772586,26.7661025 37.3666948,25.8555387 36.2434764,25.8555387 Z M26.9246053,28.6204085 C26.9246053,28.6204085 27.1806819,29.9231035 26.1897768,29.9231035 L25.1988718,29.9231035 L25.1988718,29.9231035 L8.4536469,29.9231035 C7.33042828,29.9231035 6.41986457,29.0125397 6.41986457,27.8893211 C6.41986457,26.7661025 7.33042828,25.8555387 8.4536469,25.8555387 L13.013413,25.8555387 C13.7495774,25.8128742 13.9241103,25.3879207 13.9241103,25.3879207 L13.9281185,25.3899694 L19.8801394,15.0807278 L19.878358,15.0803715 C19.9868899,14.8812107 19.8965283,14.6930501 19.8808073,14.6632562 L17.9151638,11.2586849 C17.3535322,10.2859502 17.6868325,9.04208613 18.6595671,8.48049908 C19.6323019,7.91886751 20.8761214,8.25216787 21.4377529,9.22490253 L22.3493855,10.8039374 L23.2594147,9.22770823 C23.8210019,8.25497357 25.0648659,7.92167323 26.0376005,8.4833048 C27.0103352,9.04493637 27.3436355,10.2888004 26.782004,11.2614906 L18.4995972,25.6069886 C18.4633903,25.6943218 18.452301,25.8314008 18.7217381,25.8555387 L23.6724775,25.8555387 L23.6735462,25.9037703 C23.6735462,25.9037703 26.5349234,25.9483054 26.9246053,28.6204085 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/AppStore.fa8d95a7b26e63c3b57110cc1de8f931.svg";
export { ForwardRef as ReactComponent };